import React from 'react'
import ArrowLink from '../DetailPerso/ArrowLink'
import ProgressSteps from '../Progres/ProgressSteps'
import UserCard from './UserCard'
import PaymentDetails from './PaymentDetails';
import Timer from './Timer';
import FloatingIcon from '../General/FloatingIcon'



function Middle() {
  return (
    <div>
        <ArrowLink/>    
        <ProgressSteps completed={3}/>    
        <UserCard/>
        <PaymentDetails />
        <Timer/>
        <FloatingIcon/>                
    </div>
  )
}

export default Middle